export default {
  labels: {
    selectOne: 'اختر خيارًا واحدًا',
    selectAll: 'اختر كل ما ينطبق',
    typeResponse: 'اكتب إجابتك في مربع النص أدناه.',
    recordResponse: 'سجّل مقطعًا للإجابة على السؤال.',
    enterNumeric: 'أدخل إجابة رقمية في الحقل أدناه.',
    rateResponseScale: 'قيّم إجابتك على المقياس المقدم.',
    sliderMinimum: 'القيمة الدنيا: {value}',
    sliderMaximum: 'القيمة القصوى: {value}',
    selectOneOptionRow: 'اختر خيارًا واحدًا في كل صف.',
    selectAllOptionsRow: 'اختر جميع الخيارات التي تنطبق لكل صف.',
    dragAndDropResponse: 'اسحب وأسقط الخيارات لترتيبها حسب التفضيل.',
    rankOrderDesktopInstruction: 'اسحب وأفلت العناصر لترتيبها، أو استخدم زر + لإضافة عنصر. استخدم أزرار الأسهم لإعادة الترتيب أو زر الحذف لإزالة عنصر.',
    alert: "تنبيه",
    error: 'يرجى إدخال رقم بين {min} و {max}.',
    cameras: 'الكاميرات',
    microphones: 'الميكروفونات',
    recording: 'التسجيل',
    noDevicesFound: 'لم يتم العثور على أجهزة',
    camera: 'الكاميرا',
    microphone: 'الميكروفون',
    stopRecording: 'إيقاف التسجيل',
    startRecording: 'بدء التسجيل',
    disableCamera: 'تعطيل الكاميرا',
    enableCamera: 'تفعيل الكاميرا',
    disableMicrophone: 'تعطيل الميكروفون',
    enableMicrophone: 'تفعيل الميكروفون',
    settings: 'الإعدادات',
    recordingProgress: 'تقدم التسجيل',
    playbackProgress: 'تقدم التشغيل',
    play: 'تشغيل',
    pause: 'إيقاف مؤقت',
    stop: 'إيقاف',
    record: 'تسجيل',
    recordAgain: 'إعادة التسجيل',
    retry: 'أعد المحاولة',
    done: 'تم',
    minRecordTime: 'يرجى تسجيل إجابة لمدة {min} ثانية.',
    enlargeImage: 'تكبير الصورة',
    enlargedImage: 'الصورة المكبرة',
    close: 'إغلاق',
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    resetZoom: 'إعادة ضبط التكبير',
    zoomLevel: 'التكبير {percentage}%',
    imagePosition: '{current} من {total}',
    previousImage: 'الصورة السابقة',
    nextImage: 'الصورة التالية',
    imageLoading: 'جارٍ تحميل الصورة',
    imageLoadFailed: 'تعذّر تحميل الصورة',
  },
  noSelection: "لا يوجد اختيار",
  actions: {
    increase: 'زيادة',
    decrease: 'تقليل'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'انتهت معاينة الاستبيان',
      titleCompleted: 'اكتملت معاينة الاستبيان',
      previewModeWarning: 'هذه الصفحة مرئية فقط في وضع المعاينة ولن تظهر للمشاركين الفعليين.',
      reachedEndPoint: 'وصلت هذه الاستبانة إلى نقطة النهاية.',
      reachedEndPointCompleted: 'وصل هذا المعاينة إلى نقطة النهاية.',
      returnToModify: 'ارجع إلى السؤال السابق لتعديل إجاباتك واختبار مسار استبانة مختلف.',
      logic: 'المنطق'
    }
  }
}
